/**
 * Assign Task To Me manifest — `assign-task-to-me` action.
 *
 * Same-entity action (see `completeTask.ts` for the zero-hop-walk pattern
 * this mirrors). Closes part of the iOS global-search catalog gap
 * (issue #2534) for `task`.
 *
 * `mode: "server"` — handler adds the caller to `contact_tasks.assigned_users`
 * via the service-role client, reusing `claimTaskFromSlack` (the same
 * mutation the Slack "Claim" quick action already uses).
 */

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "assign-task-to-me",
  label: "Assign to me",
  primaryEntity: "task",
  requires: {
    entity: "task",
    requiredFields: [],
  },
  mode: "server",
});
